import { Component, OnInit } from '@angular/core';
import { skipWhile, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { getSP, getBanks } from '@flexus/core';
import { Store } from '@ngrx/store';
@Component({
	selector: 'flx-billing-account-details',
	templateUrl: './account-details.component.html',
	styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit {
	accountDetails;
	constructor(private store: Store<any>) {}

	ngOnInit(): void {
		combineLatest([this.store.select(getSP), this.store.select(getBanks)])
			.pipe(
				skipWhile(x => !x[0] || !x[1]),
				take(1)
			)
			.subscribe(([sp, banks]) => {
				console.log({ sp, banks });

				this.accountDetails = {
					b_acc_holder: sp.b_acc_holder,
					b_acc_type: sp.b_acc_type,
					b_bank_name: banks.find(bank => bank.id === sp.b_bank_name).name || '',
					b_branch_name: sp.b_branch_name,
					b_branch_code: sp.b_branch_code,
					b_acc_no: sp.b_acc_no
				};
			});
	}
}
